<template>
  <div class="monitor-center">
    <div class="monitor-center-top">
      <keyword-search class="monitor-center-top-keyword-search"
        :searchKeyword="searchKeyword"
        @onSearchClick="onKeywordSearchSearchClick"></keyword-search>
      <query-type-selector class="monitor-center-top-query-type-selector" v-model="quertType" :totalCount="totalNumber"
        :onlineCount="onlineNumber" :abnormalCount="abnormalNumber"></query-type-selector>
    </div>
    <page-list-container class="monitor-center-bottom" :total="total" :pageSize="pageSize" fixedSize
      :inputCurrentPage="currentPage" @onPageChange="onPageChange">
      <div class="monitor-center-bottom-list">
        <div class="monitor-center-bottom-list-item" v-for="(item, index) of rawDeviceArray" :key="index">
          <cell class="monitor-center-bottom-list-item-content" :model="item" @onCellClick="onCellClick"></cell>
        </div>
      </div>
    </page-list-container>
    <el-drawer :visible.sync="isShowDrawer" :with-header="false" destroy-on-close>
      <device-detail-panel :model="selectedDeviceModel" @onUnbindButtonClick="onUnbindButtonClick"
        @onBindButtonClick="onBindButtonClick" @onEditButtonClick="onEditButtonClick"></device-detail-panel>
    </el-drawer>
    <monitor-center-alert-bind v-if="isShowAlertBind" v-model="isShowAlertBind" :model="selectedDeviceModel"
      @onBindComplete="onBindComplete"></monitor-center-alert-bind>
    <monitor-center-alert-unbind v-if="isShowAlertUnbind" v-model="isShowAlertUnbind" :model="selectedDeviceModel"
      @onUnbindComplete="onUnbindComplete"></monitor-center-alert-unbind>
    <monitor-center-alert-edit v-if="isShowAlertEdit" v-model="isShowAlertEdit" :model="selectedDeviceModel"
      @onEditComplete="onEditComplete"></monitor-center-alert-edit>
  </div>
</template>

<script>
import KeywordSearch from "@c/monitor-center/keyword-search.vue";
import QueryTypeSelector from "@c/monitor-center/query-type-selector.vue";
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import Cell from "@c/monitor-center/cell.vue";
import DeviceDetailPanel from "@c/monitor-center/device-detail-panel/device-detail-panel.vue";
import MonitorCenterAlertBind from "@c/monitor-center/alert/monitor-center-alert-bind.vue";
import MonitorCenterAlertUnbind from "@c/monitor-center/alert/monitor-center-alert-unbind.vue";
import MonitorCenterAlertEdit from "@c/monitor-center/alert/monitor-center-alert-edit.vue";

export default {
  components: {
    KeywordSearch,
    QueryTypeSelector,
    PageListContainer,
    Cell,
    DeviceDetailPanel,
    MonitorCenterAlertBind,
    MonitorCenterAlertUnbind,
    MonitorCenterAlertEdit
  },

  data: function () {
    return {
      //quertTypeSelector
      quertType: MONITOR_CENTER_QUERY_TYPE.全部设备,
      totalNumber: 0, //全部设备数
      onlineNumber: 0, //在线设备数
      abnormalNumber: 0, //异常设备数
      //deviceList
      rawDeviceArray: [],
      total: 0, // 显示总条数
      pageSize: 20, // 默认每页显示条数，避免undefined
      currentPage: 1, // 当前的页数
      //search
      keyword: '', // 搜索关键词
      searchKeyword: '', // 传递给搜索组件的关键词
      //drawer
      isShowDrawer: false,
      selectedDeviceID: undefined,
      selectedDeviceModel: undefined,
      //alert
      isShowAlertBind: false,
      isShowAlertUnbind: false,
      isShowAlertEdit: false,
      //跨项目跳转相关
      hasProcessedJumpSN: false, // 防止重复处理跳转SN
      //定时器
      detailRefreshTimer: null // 用于存储设备详情刷新定时器的ID
    };
  },

  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid;
    },
    
    // 获取跨项目跳转的SN
    searchSN() {
      return this.$store.state.searchSN;
    }
  },

  watch: {
    hospitalID() {
      this.currentPage = 1;
      this.deviceListRequest();
    },

    quertType(value) {
      this.currentPage = 1;
      this.quertType = value;
      this.deviceListRequest();
    },
    
    // 监听跨项目跳转的SN
    searchSN: {
      handler(newSN) {
        if (newSN && !this.hasProcessedJumpSN) {
          this.handleJumpToDeviceBySN(newSN);
        }
      },
      immediate: true
    },
    
    // 监听抽屉开关状态，关闭时清除定时器
    isShowDrawer(newVal) {
      if (!newVal && this.detailRefreshTimer) {
        clearInterval(this.detailRefreshTimer);
        this.detailRefreshTimer = null;
      }
    }
  },

  mounted() {
    // 初始化 pageSize
    this.initializePageSize();
    // 初始加载数据
    this.deviceListRequest();
  },
  
  beforeDestroy() {
    // 组件销毁时清除定时器，防止内存泄漏
    if (this.detailRefreshTimer) {
      clearInterval(this.detailRefreshTimer);
      this.detailRefreshTimer = null;
    }
  },

  methods: {
    // 初始化页面大小
    initializePageSize() {
      const rowItemCount = Math.floor((window.innerWidth - 296) / 190);
      if (rowItemCount) {
        this.pageSize = 4 * rowItemCount;
      } else {
        this.pageSize = 20;
      }
    },

    // 处理跨项目跳转到指定设备（通过SN）
    async handleJumpToDeviceBySN(sn) {
      this.hasProcessedJumpSN = true;
      
      try {
        console.log(`正在搜索设备: ${sn}`);
        
        // 确保 pageSize 已初始化
        if (!this.pageSize) {
          this.initializePageSize();
        }
        
        // 设置搜索关键词并触发搜索
        this.searchKeyword = sn;
        this.keyword = sn;
        await this.deviceListRequest();
        
        // 在搜索结果中找到匹配的设备并打开详情
        await this.openDeviceDetailBySN(sn);
        
        // 3秒后清除SN信息，避免重复处理
        setTimeout(() => {
          this.$store.commit('clearSearchSN');
          this.hasProcessedJumpSN = false;
        }, 3000);
        
      } catch (error) {
        console.error('处理跳转设备失败:', error);
        this.hasProcessedJumpSN = false;
      }
    },
    
    // 在搜索结果中找到设备并打开详情
    async openDeviceDetailBySN(sn) {
      try {
        // 等待搜索结果加载完成
        await this.$nextTick();
        
        // 在搜索结果中找到匹配的设备
        const targetDevice = this.rawDeviceArray.find(device => device.sn === sn);
        
        if (targetDevice) {
          // 找到设备，打开详情
          this.selectedDeviceID = targetDevice.id;
          await this.deviceDetailRequest();
          
          console.log(`成功定位到设备: ${sn}`);
        } else {
          console.warn(`未找到设备: ${sn}`);
          // 可以显示提示信息
          // this.$toast.showRed(`未找到设备: ${sn}`);
        }
      } catch (error) {
        console.error(`打开设备详情失败: ${sn}`, error);
      }
    },

    onKeywordSearchSearchClick(keyword) {
      this.currentPage = 1;
      this.keyword = keyword;
      this.deviceListRequest();
    },

    //分页
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.deviceListRequest();
    },

    async deviceListRequest() {
      try {
        // 确保 pageSize 有值
        if (!this.pageSize) {
          this.initializePageSize();
        }

        const params = {
          "keyWord": this.keyword,
          "status": this.quertType,
          "pageNum": this.currentPage,
          "hospitalId": this.hospitalID,
          "pageSize": this.pageSize,
        }
        
        const response = await this.$api.getMoniterCenterData(params)
        this.rawDeviceArray = response.list.list;
        this.total = response.list.total;
        this.totalNumber = response.totalNum;
        this.onlineNumber = response.onlineNum;
        this.abnormalNumber = response.abnormalNum;
      } catch (error) {
        this.rawDeviceArray = []
        this.$toast.showRed(error);
      }
    },

    //cell
    onCellClick(model) {
      this.selectedDeviceID = model.id
      this.deviceDetailRequest()
      
      // 清除已存在的定时器，避免多个定时器同时运行
      if (this.detailRefreshTimer) {
        clearInterval(this.detailRefreshTimer);
      }
      
      // 启动每3秒刷新一次设备详情的定时器
      this.detailRefreshTimer = setInterval(() => {
        if (this.isShowDrawer) { // 确保抽屉是打开状态才刷新
          this.deviceDetailRequest();
        }
      }, 3000);
    },

    async deviceDetailRequest() {
      try {
        const params = { "id": this.selectedDeviceID }
        const response = await this.$api.getMonitorCenterDeviceDetail(params)

        if (response.online == false) {
          response.bloodOxygen = '';
          response.breathRate = '';
          response.heartRate = '';
          response.networkType = null;
          response.deviceConnectStatus = 1;
          response.connectStatus = null;
          response.battery = 0;
          response.powerStatus = null;
        } else {
          if (response.deviceConnectStatus == 1) {
            response.connectStatus = null;
            response.battery = 0;
            response.powerStatus = null;
          }
        }

        this.selectedDeviceModel = response
        this.isShowDrawer = true
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    //drawer
    onUnbindButtonClick() {
      this.isShowAlertUnbind = true
    },

    onBindButtonClick() {
      this.isShowAlertBind = true
    },

    onEditButtonClick() {
      this.isShowAlertEdit = true
    },

    //bindAlert
    onBindComplete(error) {
      if (error) {
        this.$toast.showRed(error)
      } else {
        this.$toast.showGreen("设备绑定成功")
        this.deviceListRequest()
        this.deviceDetailRequest()
        this.isShowAlertBind = false
      }
    },

    //unbindAlert
    onUnbindComplete(error) {
      if (error) {
        this.$toast.showRed(error)
      } else {
        this.$toast.showGreen("设备解绑成功")
        this.deviceListRequest()
        this.deviceDetailRequest()
        this.isShowAlertUnbind = false
      }
    },

    //editAlert
    onEditComplete(error) {
      if (error) {
        this.$toast.showRed(error)
      } else {
        this.$toast.showGreen("设备编辑成功")
        this.deviceListRequest()
        this.deviceDetailRequest()
        this.isShowAlertEdit = false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/* CSS 保持不变 */
.monitor-center {
  width: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;

  &-top {
    width: 100%;
    height: rem(32);
    flex-shrink: 0;

    &-keyword-search {
      width: rem(320);
      height: 100%;
      float: left;
    }

    &-query-type-selector {
      height: 100%;
      margin-left: rem(13);
      float: left;
    }
  }

  &-bottom {
    background-color: #f0f2f5 !important;
    margin-top: rem(7);
    width: 100%;

    &-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    

      &-item {
        width: 190px;
        height: 170px;
        box-sizing: border-box;
        padding-top: rem(10);
        padding-right: rem(10);
        display: flex;
        align-items: center;
        justify-content: center;

        &-content {
          background-color: white;
          border-radius: rem(4);

        }
      }
    }

    &-empty-info {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(14);
      width: 100%;
      margin-top: rem(100);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-pagination {
      width: 100%;
      height: rem(90);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>